import CircularProgress from '@mui/material/CircularProgress'
import { connectorAPI } from 'actions/connector.js'
import clsx from 'clsx'
import { AuthTemplate } from 'components/templates/authTemplate'
import isEmpty from 'lodash/isEmpty'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { appConnector } from 'shared/connector'
import { notifyError } from 'shared/errors/notificate.ts'
import { typo } from 'shared/styles'
import { Button, StackIcon } from 'shared/ui'
import { ControlledDialog } from 'shared/ui/Dialog'

import type { Profile } from './type'

import css from './NoLinkedinContainer.module.scss'

const cn = AuthTemplate.cn

export interface ModalConfirmLinkedInProfileProps {
	onClose: () => void
	open: boolean
	profile?: Profile
}
export function ModalConfirmLinkedInProfile({
	onClose,
	open,
	profile
}: ModalConfirmLinkedInProfileProps) {
	const { push } = useHistory()

	const [actionDone, setActionDone] = useState(false)
	const [loader, setLoader] = useState(false)

	const handlerModal = () => {
		if (!loader) {
			onClose()
		}
	}

	const handlerModalLink = async () => {
		if (loader) {
			return
		}

		setLoader(true)
		setActionDone(false)
		try {
			const metadata = appConnector.utils.createMetadata()
			const loaded = await appConnector.api.addLinkedInProfile(
				profile,
				metadata
			)

			await appConnector.auth.switchToWorkspace(loaded.id, metadata)
			await connectorAPI.getLinkedProfile()
			setActionDone(true)
		} catch (error) {
			handlerModal()
			notifyError(error)
		} finally {
			setLoader(false)
		}
	}

	return (
		<ControlledDialog
			className={css.modalInner}
			onRequestClose={() => {
				handlerModal()
				if (actionDone) {
					push('/contacts')
					document.location.reload()
				}
			}}
			open={open}
			rootClassName={`${css.dialog} app-scroll`}
		>
			<button
				aria-label='Close.'
				className={css.close}
				onClick={handlerModal}
				title='Close.'
				type='button'
			>
				<StackIcon icon='close' stroke='currentcolor' width={9} />
			</button>

			<div className={css.bodyModal}>
				<h2>Link this account?</h2>

				<p className={cn.text}>You cannot change it later!</p>

				{!isEmpty(profile) && (
					<>
						<div className='modal-create-linked__avatar'>
							{profile.picture ? (
								<img alt='pictureUrl' src={profile.picture} />
							) : (
								<div className='fake-img' />
							)}

							<div className='modal-create-linked__avatar-in' />
						</div>

						<h3>
							{profile.firstName} {profile.lastName}
						</h3>

						<a
							className={clsx(css.email, typo.mediumBody)}
							href={`https://www.linkedin.com/in/${profile.publicIdentifier}`}
							rel='noopener noreferrer'
							target='_blank'
						>
							{' '}
							{`https://www.linkedin.com/in/${profile.publicIdentifier}`}
						</a>

						<div className={css.actions}>
							<Button
								className={css.action}
								onClick={handlerModal}
								type='button'
								typography={typo.largeButton}
								variant='secondary'
							>
								Back
							</Button>

							<Button
								className={css.action}
								onClick={handlerModalLink}
								type='button'
								typography={typo.largeButton}
							>
								{loader ? (
									<CircularProgress
										classes={{ colorPrimary: 'material-loader-black' }}
										size={20}
									/>
								) : (
									'Link'
								)}
							</Button>
						</div>
					</>
				)}
			</div>
		</ControlledDialog>
	)
}
